import React, { useEffect, useState } from 'react'
import  { useUserAdminExtend } from '../../../hooks/useAdminUser';
import { Organization } from '../../../../organization/types/organization.types';
import { useAuth } from '../../../../auth/hooks';
import { userRoles } from '../../../types/user.types';
import FilterButtonDrawer, { FilterDrawerContainer, FilterStatusItem } from '../../../../../common/components/atom/FilterButtonDrawer/FilterButtonDrawer';
import OrganizationPicker from '../../../../organization/components/OrganizationPicker/OrganizationPicker';
import SingleOrganization from '../../../../organization/components/SingleOrganization';

export const UserFilterPresenter = () => {
  const {
    userAdminExtendListQuery: {  removeFromFilter , currentFilterObject, setFilterObject },
  } = useUserAdminExtend();
  const [organizationFilter, setOrganizationFilter] = useState<
    Organization | undefined
  >();

  const { userRole } = useAuth();

  
  useEffect(() => {
    if (organizationFilter) {
      setFilterObject({
        organization_id: {
          operator: "eq",
          values: [organizationFilter.organization_id],
          attribute: "organization_id",
        },
      });
    }
  }, [organizationFilter]); // eslint-disable-line


  if (userRole && (userRole < userRoles.SUPER_ADMIN)) {
    return <></>
  }



  
  return (

      <FilterButtonDrawer
        label="Filtre"
        childrenRender={({ closeDrawer }) => (
          <FilterDrawerContainer>
            <OrganizationPicker
              label="Organisation"
              setOrganization={setOrganizationFilter}
              currentOrganization={organizationFilter}
              style={{ height: 35, width: 250 }}
            />
          </FilterDrawerContainer>
        )}
        filterStatusRender={
          currentFilterObject?.organization_id?.values[0]
            ? () => (
                <>
                  <FilterStatusItem
                    labelRender={() => (
                      <SingleOrganization.Info
                        id={
                          currentFilterObject?.organization_id
                            ?.values[0] as string
                        }
                        info="organization_name"
                      />
                    )}
                    onClickDelete={() => {
                      removeFromFilter(["organization_id"]);
                      setOrganizationFilter(undefined);
                    }}
                  />
                </>
              )
            : undefined
        }
      />

  );
  
};


